import React from 'react';
import { ReactReduxContextValue } from 'react-redux';

const LocalStoreContext = React.createContext<ReactReduxContextValue>({} as ReactReduxContextValue);
export default LocalStoreContext;
